import { useResource } from "../../resource";

export const getWorkloadResourceQuery = /* GraphQL */ `
  query GetResource($ResourceId: ID) {
    getResource(resourceId: $ResourceId) {
      ClientAccountId
      Description
      StackUpdated
      Metrics
      ResourceId
      ResourceType
      ResourceSubtype
      ... on Workload {
        ExecutionType
        ContainerType
        WorkloadInputs
        DataConfiguration {
          SourceDatasets {
            ResourceId
            Description
            Location
          }
          TargetDataset {
            ResourceId
            Description
            Location
          }
        }
        ArrivalFeedConfiguration
        ClusterConfiguration
        ControllerConfiguration
        WorkloadConfiguration
      }
    }
  }
`;

export const getWorkloadDataConfigurationQuery = /* GraphQL */ `
  query GetResource($ResourceId: ID) {
    getResource(resourceId: $ResourceId) {
      ClientAccountId
      ResourceId
      ResourceType
      ... on Workload {
        DataConfiguration {
          SourceDatasets {
            ResourceId
            Description
            Location
          }
          TargetDataset {
            ResourceId
            Description
            Location
          }
        }
      }
    }
  }
`;

export const useWorkload = (resourceId, clientAccountId=null) => {
  return useResource(resourceId, clientAccountId, { query: getWorkloadResourceQuery });
};

export const useWorkloadDataConfiguration = (resourceId, clientAccountId=null) => {
  return useResource(resourceId, clientAccountId, { 
    query: getWorkloadDataConfigurationQuery,
    inlineJsonDepth: 2
  });
};
